/**
 * 「从我的作品里挑一张图」的只读取数(entity 层)。
 *
 * ★为什么在 entities 而不是直接 import posterService:FSD 单向核心 —— features 互不 import
 * (eslint `no-restricted-imports` 会红)。数字人线要用海报线的产物,共享能力就得提到 entity。
 * 这里只封装**读**:列作品 + 列作品里的图,不碰任何海报业务逻辑。
 */
import { api } from "@/shared/api";

/** 可挑选的作品(一次出图任务)。 */
export interface PickableWork {
  id: number;
  name: string;
  coverThumbUrl?: string | null;
}

/** 作品里的一张图。 */
export interface PickableImage {
  id: number;
  seq: number;
  status: string;
  thumbUrl?: string | null;
  baseUrl?: string | null;
}

interface PageResp<T> {
  records: T[];
  total: number;
}

export const pickableMedia = {
  /** 成功出图作品一页(带封面缩略图,一次请求;刻意不做「拉全部作品的全部资产」那种 N+1)。
   *  2026-09-09 加 page:此前恒 page=0,作品多于一页的在选画面弹框里凭空消失。 */
  listWorks: (page = 0, size = 24) =>
    api.get<PageResp<PickableWork>>(`/poster/tasks?page=${page}&size=${size}&status=SUCCESS`),

  /** 某件作品里的图(点开才拉)。 */
  listImages: (taskId: number) => api.get<PickableImage[]>(`/poster/tasks/${taskId}/assets`),
};
